import { atom } from 'recoil';

const isLoadingClinicsState = atom({
  key: 'isLoadingClinicsState',
  default: false,
});

export const isLoadingTherapistServicesState = atom({
  key: 'isLoadingTherapistServicesState',
  default: false,
});

export const isLoadingAvailabilitiesState = atom({
  key: 'isLoadingAvailabilitiesState',
  default: false,
});

export const isLoadingPriceState = atom({
  key: 'isLoadingPriceState',
  default: false,
});

export const isLoadingRegionsState = atom({
  key: 'isLoadingRegionsState',
  default: false,
});

export const isLocatingState = atom({
  key: 'isLocatingState',
  default: false,
});

export const isValidatingCustomerState = atom({
  key: 'isValidatingCustomerState',
  default: null,
});

export default isLoadingClinicsState;
